import React from "react";
import { PhotoLibraryIcons } from "../../../utils/B2B/PhotoLibraryContent";
import "./addAttachmentPromptBox.scss";
import { IAttachmentFile } from "../../../interfaces/corporateEvent";

interface IAddAttachmentPromptBoxProps {
	maxAttachments: number;
	attachments: IAttachmentFile[];
	removePhoto: (photoId: string) => void;
	setIsOpen: (isOpen: boolean) => void;
}

const AddAttachmentPromptBox = ({
	maxAttachments,
	attachments,
	removePhoto,
	setIsOpen,
}: IAddAttachmentPromptBoxProps) => {
	return (
		<div className="photo-library-container">
			<div className="attachments-header">
				<span className="attachments-label">Attachments</span>
				<span className="photo-count">{attachments.length}/{maxAttachments}</span>
			</div>

			{attachments.length === 0 ? (
				<div className={`photo-dropzone-compact`} onClick={() => setIsOpen(true)}>
					<div className="dropzone-content">
						<div className="dropzone-icon">
							<PhotoLibraryIcons.Camera />
						</div>
						<div className="dropzone-main-text">Add photos</div>
						<div className="dropzone-sub-text">Access your photo library or upload new images</div>
					</div>

					<div className="library-hover-tooltip">
						<PhotoLibraryIcons.Grid />
						<span>Access photo library</span>
					</div>
				</div>
			) : (
				<div className="selected-photos-grid">
					{attachments.map((photo, index) => (
						<div key={photo.id} className="selected-photo-item">
							<img src={photo.fileUrl} alt={photo.fileName} />
							<div className="photo-overlay">
								<button className="remove-photo-btn" onClick={() => removePhoto(photo.id as string)}>
									<PhotoLibraryIcons.Close />
								</button>
							</div>
							<div className="photo-number">{index + 1}</div>
						</div>
					))}

					{attachments.length < maxAttachments && (
						<div className="add-more-box" onClick={() => setIsOpen(true)}>
							<div className="add-more-icon">
								<PhotoLibraryIcons.Plus />
							</div>
							<div className="add-more-text">Add more</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default AddAttachmentPromptBox;
